import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'wsb-grid-selectfilter-priority-renderer',
  template: `
    <ng-select
      *ngIf="!hide"
      [items]="displayedOptions"
      bindLabel="label"
      bindValue="value"
      [(ngModel)]="select"
      (change)="onNgSelectChange($event)"
      class="form-control auto-grow"
      [clearable]="false"
      appendTo=".atlas-grid"
    >
      <ng-template ng-label-tmp let-item="item">
        <span *ngIf="!item.notranslate">{{ item.label | translate }}</span>
        <span *ngIf="item.notranslate">{{ item.label }}</span>
      </ng-template>
      <ng-template ng-option-tmp let-item="item">
        <span *ngIf="!item.notranslate">{{ item.label | translate }}</span>
        <span *ngIf="item.notranslate">{{ item.label }}</span>
      </ng-template>
      <ng-template ng-footer-tmp *ngIf="!showAll && optionsPriority.length">
        <button (click)="showMore()" class="btn btn-link p-0">{{ 'show_more' | translate }}</button>
      </ng-template>
    </ng-select>
  `,
  standalone: false
})
export class SelectfilterPriorityRendererComponent implements ICellRendererAngularComp {
  params: any;
  options: any[] = [];
  displayedOptions: any[] = [];
  select: any;
  onChange: (value: any) => void;
  hide = false;
  showAll = false;
  optionsPriority: any[] = [];

  agInit(params: any): void {
    this.params = params;
    this.hide = this.params.hide && this.params.hide instanceof Function ? this.params.hide(params) : false;
    const selval = this.params.select ? this.params.select() : null;
    this.options = this.params.options ? this.params.options() : [];
    this.optionsPriority = this.params.optionsPriority ? this.params.optionsPriority() : [];
    if (this.optionsPriority.length) {
      this.displayedOptions = this.optionsPriority;
      const found = this.options.find(option => option.value === selval);
      if (found) {
        this.displayedOptions.push(found);
        this.options = this.options.filter(option => option.value !== selval);
      }
    } else {
      this.displayedOptions = this.options;
    }

    this.select = selval ? selval : this.displayedOptions.length ? this.displayedOptions[0].value : null;
    this.onChange = this.params.onChange;
    if (this.params.afterLoad) {
      this.params.afterLoad(this.select);
    }
  }

  showMore() {
    this.showAll = true;
    this.displayedOptions = [...this.displayedOptions, ...this.options];
  }

  onNgSelectChange(option: { label: string; value: any }) {
    this.select = option.value;
    if (this.onChange) {
      this.onChange(option.value);
    }
  }

  refresh(params: any): boolean {
    return false;
  }
}
